import { render, staticRenderFns } from "./EntityOverviewCustomFieldsWidget.vue?vue&type=template&id=36cb2228"
import script from "./EntityOverviewCustomFieldsWidget.vue?vue&type=script&lang=js"
export * from "./EntityOverviewCustomFieldsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports